module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.element) ? _c('div', {
    staticClass: "element-control",
    attrs: {
      "xxxxclass": {
        'full-height': !(_vm.parent)
      },
      "id": _vm.element.title
    }
  }, [(_vm.componentName && _vm.element.type != 'Group') ? _c(_vm.componentName, {
    tag: "component",
    attrs: {
      "parent": _vm.parent,
      "element": _vm.element
    },
    on: {
      "change": _vm.valueChanged
    }
  }) : _vm._e(), _vm._v(" "), (_vm.element.type == 'Group') ? _c('SectionLayout', {
    attrs: {
      "section": _vm.element,
      "parent": _vm.parent
    }
  }, [_c('SortableList', {
    attrs: {
      "items": _vm.element.elements
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var item = ref.item;

        return [_c('ElementControl', {
          attrs: {
            "element": item,
            "parent": _vm.element
          }
        })]
      }
    }, {
      key: "menu",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.$set(item, 'value', null)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Clear Value")])], 1), _vm._v(" "), (!item.na) ? _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.$set(item, 'na', true)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Not Applicable")])], 1) : _vm._e(), _vm._v(" "), (item.na) ? _c('v-list-item', {
          on: {
            "click": function($event) {
              return _vm.$set(item, 'na', null)
            }
          }
        }, [_c('v-list-item-title', [_vm._v("Mark Applicable")])], 1) : _vm._e()]
      }
    }], null, false, 2663346918)
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a60e0b6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/ElementControl.vue
// module id = 2638
// module chunks = 1